import { render, staticRenderFns } from "./LmFooter.vue?vue&type=template&id=67e615c4&scoped=true"
import script from "./LmFooter.vue?vue&type=script&lang=js"
export * from "./LmFooter.vue?vue&type=script&lang=js"
import style0 from "./LmFooter.vue?vue&type=style&index=0&id=67e615c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e615c4",
  null
  
)

export default component.exports